import { Routes } from '@angular/router';
import { DealerContactComponent } from './components/dealer-contact/dealer-contact.component';
import { ProfileMobileComponent } from './components/profile-mobile/profile-mobile.component';
import { DealerCreditComponent } from './components/dealer-credit/dealer-credit.component';
import { DesktopOnlyGuard } from './guards/desktop-only.guard';
import { MobileOnlyGuard } from './guards/mobile-only.guard';
import { AlertsOthersComponent } from './components/alerts-others/alerts-others.component';
import { AlertsSellersComponent } from './components/alerts-sellers/alerts-sellers.component';
import { AlertsBuyersComponent } from './components/alerts-buyers/alerts-buyers.component';
import { UserContactComponent } from './components/user-contact/user-contact.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { UnsavedFormGuard } from './guards/unsaved-form.guard';
import { ServiceCarfaxComponent } from './components/service-carfax/service-carfax.component';
import { AutoCheckComponent } from './components/auto-check/auto-check.component';
import { DealerSellerComponent } from './components/dealer-seller/dealer-seller.component';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import { AuthGuard, LaunchDarklyUserGuard } from 'remarketing-angular-library';
import { AlertsAlertsComponent } from './components/alerts-alerts/alerts-alerts.component';

export const profileManagementRoutes: Routes = [
  {
    path: 'profile-management',
    loadComponent: () => import('./components/profile-shell/profile-shell.component').then(c => c.ProfileShellComponent),
    canActivate: [AuthGuard, AgreementsGuard],
    data: {
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    },
    children: [
      {
        path: '',
        component: ProfileMobileComponent,
        canActivate: [MobileOnlyGuard],
        canDeactivate: [UnsavedFormGuard],
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent,
        canActivate: [LaunchDarklyUserGuard],
        canDeactivate: [UnsavedFormGuard],
        data : { flag: 'profileAndSettings-changePassword-enabled'},
      },
      {
        path: 'contact-information',
        component: UserContactComponent,
        canActivate: [DesktopOnlyGuard, LaunchDarklyUserGuard],
        canDeactivate: [UnsavedFormGuard],
        data : { flag: 'profileAndSettings-contactInformation-enabled'},
      },
      {
        path: 'dealer-contact',
        component: DealerContactComponent,
        canActivate: [LaunchDarklyUserGuard],
        canDeactivate: [UnsavedFormGuard],
        data : { flag: 'profileAndSettingsEnabled'},
      },
      {
        path: 'dealer-buyer',
        component: DealerCreditComponent,
        canActivate: [DesktopOnlyGuard, LaunchDarklyUserGuard],
        data : { flag: 'profileAndSettingsEnabled'},
      },
      {
        path: 'dealer-seller',
        component: DealerSellerComponent,
        canActivate: [LaunchDarklyUserGuard],
        canDeactivate: [UnsavedFormGuard],
        data : { flag: 'profileAndSettingsEnabled'},
      },
      {
        path: 'invalid-link',
        redirectTo: 'contact-information',
        pathMatch: 'full'
      },
      {
        path: 'manage-alerts',
        children: [
          {
            path: '',
            redirectTo: 'others',
            pathMatch: 'full'
          },
          {
            path:'alerts',
            component: AlertsAlertsComponent,
            canActivate: [DesktopOnlyGuard, LaunchDarklyUserGuard],
            canDeactivate: [UnsavedFormGuard],
            data : { flag: 'profileAndSettingsEnabled'},
          },
          {
            path: 'others',
            component: AlertsOthersComponent,
            canActivate: [DesktopOnlyGuard, LaunchDarklyUserGuard],
            canDeactivate: [UnsavedFormGuard],
            data : { flag: 'profileAndSettingsEnabled'},
          },
          {
            path: 'sellers',
            component: AlertsSellersComponent,
            canActivate: [DesktopOnlyGuard, LaunchDarklyUserGuard],
            canDeactivate: [UnsavedFormGuard],
            data : { flag: 'profileAndSettingsEnabled'},
          },
          {
            path: 'users',
            component: AlertsBuyersComponent,
            canActivate: [DesktopOnlyGuard, LaunchDarklyUserGuard],
            canDeactivate: [UnsavedFormGuard],
            data : { flag: 'profileAndSettingsEnabled'},
          }
        ]
      },
      {
        path: 'manage-services',
        children: [
          {
            path: '',
            redirectTo: 'carfax',
            pathMatch: 'full'
          },
          {
            path: 'carfax',
            component: ServiceCarfaxComponent,
            canActivate: [DesktopOnlyGuard, LaunchDarklyUserGuard],
            canDeactivate: [UnsavedFormGuard],
            data : { flag: 'profileAndSettingsEnabled'},
          },
          {
            path: 'autocheck',
            component: AutoCheckComponent,
            canActivate: [DesktopOnlyGuard, LaunchDarklyUserGuard],
            canDeactivate: [UnsavedFormGuard],
            data : { flag: 'profileAndSettingsEnabled'},
          }
        ]
      }
    ]
  }
];
